import { isTrackCaptionKind, Tooltip, useMediaRemote, useMediaState } from "@vidstack/react";
import { BraivCaptionOffIcon, BraivCaptionOnIcon } from "@/components/player/layouts/shared/playerIcons";
import React from "react";
import { MediaButtonProps } from "@/components/player/layouts/shared/buttons";
import { usePlayerLanguageContext } from "@/components/player/language/PlayerLanguageContext";
export function CaptionButton({
  tooltipPlacement
}: MediaButtonProps) {
  const track = useMediaState('textTrack');
  const hasCaptions = useMediaState('hasCaptions');
  const isOn = track && isTrackCaptionKind(track);
  const {
    setCaptionShowing
  } = usePlayerLanguageContext();
  const onPress = () => {
    console.debug('Toggling captions, active track:', track);
    if (isOn) {
      setCaptionShowing(false);
    } else {
      setCaptionShowing(true);
    }
  };
  const isHidden = !hasCaptions;
  return <Tooltip.Root data-sentry-element="unknown" data-sentry-component="CaptionButton" data-sentry-source-file="CaptionButton.tsx">
            <Tooltip.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="CaptionButton.tsx">
                {!isHidden && <div className="vds-button" onClick={onPress} onTouchEnd={onPress}>
                        {isOn ? <BraivCaptionOnIcon /> : <BraivCaptionOffIcon />}
                    </div>}
            </Tooltip.Trigger>
            <Tooltip.Content className="vds-tooltip-content" placement={tooltipPlacement} data-sentry-element="unknown" data-sentry-source-file="CaptionButton.tsx">
                {isOn ? 'Closed-Captions Off' : 'Closed-Captions On'}
            </Tooltip.Content>
        </Tooltip.Root>;
}